import React from 'react';
import { Check } from 'lucide-react';
const ITEMS = ['У вас диагноз гонартроз или коксартроз 3-4 степени', 'Боль в суставе не проходит месяцами', 'Стало трудно подниматься по лестнице, изменилась походка', 'Обезболивающие и консервативное лечение уже не помогают', 'Вы готовы приехать на операцию в Санкт-Петербург'];
export function WhoThisIsFor() {
  return <section className="w-full bg-slate-50" data-id="element-110">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:px-6 lg:py-20" data-id="element-111">
        <h2 className="text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl lg:text-3xl" data-id="element-112">
          Вам стоит обратиться, если:
        </h2>

        <ul className="mt-8 space-y-4" data-id="element-113">
          {ITEMS.map(item => <li key={item} className="flex items-start gap-4 rounded-2xl border border-slate-100 bg-white p-5" data-id="element-114">
              <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-green-100" data-id="element-115">
                <Check className="h-4 w-4 text-green-600" aria-hidden="true" data-id="element-116" />
              </span>
              <span className="text-lg leading-relaxed text-slate-700" data-id="element-117">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="mt-8 text-lg leading-relaxed text-slate-600" data-id="element-118">
          Если хотя бы несколько пунктов про вас — запишитесь на консультацию
          перед операцией.
        </p>
      </div>
    </section>;
}